export default __webpack_public_path__ + "starwars.png";